import { render } from "./EditOnboarding.vue?vue&type=template&id=7fcb593e&scoped=true"
import script from "./EditOnboarding.vue?vue&type=script&lang=js"
export * from "./EditOnboarding.vue?vue&type=script&lang=js"

import "./EditOnboarding.vue?vue&type=style&index=0&id=7fcb593e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fcb593e"]])

export default __exports__